<div class="container">
    <div class="wrapper">
        <h1 class="pageTitle" id="main-content" >
            {{pageTitle}}</h1>
        <h2 class="govuk-heading-m">{{verifyPageText}}</h2>
        @if(webhookResponseStatus) {
          <p class="govuk-body-l">{{ webhookResponseStatus | translate }}</p>
        }

        @if(paymentCancelled) {
          <p class="govuk-body">{{ 'COMMON.PAYMENT_CANCELLED_BODY' | translate }}</p>
        }

        @if(paymentAlreadyPaid) {
          <div [innerHTML]="'COMMON.PAYMENT_ALREADY_PAID_BODY' | translate: { serviceId: ref }"></div>
        }

        @if(maxRetriesReached) {
          <div class="govuk-notification-banner" role="region" aria-labelledby="payment-verify-notification-banner-title"
            data-module="govuk-notification-banner">
            <div class="govuk-notification-banner__header">
              <h2 class="govuk-notification-banner__title" id="payment-verify-notification-banner-title">
                Important
              </h2>
            </div>
            <div class="govuk-notification-banner__content"
              [innerHTML]="'COMMON.PAYMENT_MAX_RETRIES_REACHED' | translate: { serviceId: ref || receipt || basket }"></div>
          </div>
        }

        @if(failed) {
          <div class="govuk-error-summary" role="alert" aria-labelledby="payment-failed-title" tabindex="-1">
            <h2 class="govuk-error-summary__title" id="payment-failed-title">
              {{ 'COMMON.PAYMENT_FAILED_TITLE' | translate }}
            </h2>
            <div class="govuk-error-summary__body">
              <p class="govuk-body">{{ 'COMMON.PAYMENT_FAILED_BODY' | translate }}</p>
              <p class="govuk-body">{{ 'COMMON.PAYMENT_CHARGE_ID' | translate }}: {{ chargeId }}</p>
              <p class="govuk-body">{{ 'COMMON.PAYMENT_RECEIPT' | translate }}: {{ receipt }}</p>
              <p class="govuk-body">{{ 'COMMON.PAYMENT_INTERNAL_REF' | translate }}: {{ ref }}</p>
            </div>
          </div>
        }

        @if(paymentFailed && !maxRetriesReached && !paymentAlreadyPaid) {
          <div class="row pb-4">
            <div class="col-sm-12">
              <button type="button" class="btn btn-primary return-button" (click)="restartJourney()">
                {{ 'COMMON.RESTART' | translate }}
              </button>
            </div>
          </div>
        }
    </div>
</div>
